
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/timeline/[[...timelineYear]]",
      function () {
        return require("private-next-pages/timeline/[[...timelineYear]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/timeline/[[...timelineYear]]"])
      });
    }
  